import { Site } from '../../../types.js';
import getConfig from '../../domainConfiguration/getConfig.js';
export default (function (host) {
    return getConfig(Site.SEEKJOBS, { host: host });
});
//# sourceMappingURL=getSeekJobsConfig.js.map